import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { FaAngleRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { securedAxiosInstance } from '../../api/axios';
import { clearComments } from '../../stores/slices/comments/commentsSlice';
import Card from '../Card';
import EditGoalItem from '../MyBox/EditGoalItem';
import GoalComments from '../MyBox/GoalComments';

const Notifications = ({ standAlone = false }) => {
  const { userInfo } = useSelector(state => state.user);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [readingNotif, setReadingNotif] = useState(null);
  const [goal, setGoal] = useState(null);
  const [openComments, setOpenComments] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const getNotifs = async () => {
      setIsLoading(true);
      const res = await securedAxiosInstance.get(
        'notifications_users/dashboard'
      );
      setNotifications(res.data.reverse());
      setIsLoading(false);
    };

    getNotifs();
  }, []);

  const showGoal = async goalId => {
    // setIsLoading(true);
    const { data } = await securedAxiosInstance.get(`/goals/${goalId}`);
    setGoal(data);
    setOpenComments(true);
    // setIsLoading(false);
    setSelectedNotif(null);
  };

  const navigateTo = async (type, refId, id) => {
    setReadingNotif(id);
    const result = await securedAxiosInstance.put(
      `/update_notification/${id}`,
      {
        read: true,
      }
    );
    setNotifications(notifications => {
      return notifications.map(notif => {
        if (notif.id === id) {
          return {
            ...notif,
            read: true,
          };
        }
        return notif;
      });
    });
    setReadingNotif(null);
    if (type === 'goal') {
      dispatch(clearComments());
      await showGoal(refId);
      // navigate('my-4boxes');
    }
    if (type === 'reminder') navigate('/dashboard/reminders');
    if (type === 'user') {
      if (userInfo.role === 'coach') {
        navigate('/dashboard/settings/organisation/user-access');
      }
      if (userInfo.role === 'employer') {
        navigate('/dashboard/settings/organisation/employees');
      }
    }
    if (type === 'organisations' || type === 'organisation')
      navigate('/dashboard/settings/organisations', { state: { refId } });

    if (type === 'form_entry') {
      window.open(
        'https://learn.4boxes.com.au/admin/inquiries',
        '_blank',
        'noopener,noreferrer'
      );
    }
    
    if (type === 'journal_template') {
      navigate('/dashboard/journal');
    }
  };
  return (
    <>
      <Card
        mx={'auto'}
        flex={'1'}
        flexGrow={'1'}
        h={'full'}
        overflowY={'hidden'}
      >
        {!standAlone && (
          <HStack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            position="relative"
            w={'full'}
            mb={'4'}
          >
            <Text fontWeight={'bold'} fontSize="md" w="full">
              Latest Notifications
            </Text>
            <Button
              color="primary"
              variant={'ghost'}
              size="xs"
              fontSize={'14px'}
              rightIcon={
                <Icon
                  as={FaAngleRight}
                  border={'1px solid'}
                  borderRadius={'4'}
                />
              }
              onClick={() => navigate('/dashboard/notifications')}
            >
              View All
            </Button>
          </HStack>
        )}
        <Box h={'full'} pb={'6'}>
          <Scrollbars>
            <Flex overflowY="hidden" flexDirection="column" flex={1} w={'full'}>
              {isLoading ? (
                <Spinner color="primary" />
              ) : notifications.length > 0 ? (
                notifications.map((notif, i) => (
                  <HStack
                    pl={notif.read === false ? '3' : '9'}
                    pr={'3'}
                    bg={i % 2 === 0 ? 'secondary' : 'transparent'}
                    justifyContent={'space-between'}
                    key={notif.id}
                  >
                    {notif.read === false && (
                      <Icon viewBox="0 0 200 200" color="primary">
                        <path
                          fill="currentColor"
                          d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
                        />
                      </Icon>
                    )}
                    <Text
                      w={'full'}
                      fontSize={'14px'}
                      fontWeight={notif.read === false ? 'bold' : 'normal'}
                      py={4}
                    >
                      {notif.notification.text}
                    </Text>
                    <IconButton
                      variant={'outline'}
                      size="xs"
                      border={'1.5px solid'}
                      borderColor={'lightGray.500'}
                      p={0}
                      color="lightGray.500"
                      _hover={{ color: 'primary', borderColor: 'primary' }}
                      icon={<FaAngleRight />}
                      isLoading={
                        readingNotif === notif.id || selectedNotif === notif.id
                      }
                      onClick={() => {
                        setSelectedNotif(notif.id);
                        navigateTo(
                          notif.notification.ref_type,
                          notif.notification.ref_id,
                          notif.id
                        );
                      }}
                    />
                  </HStack>
                ))
              ) : (
                <Text>No notifications yet.</Text>
              )}
            </Flex>
          </Scrollbars>
        </Box>
      </Card>
      {isOpen && (
        <EditGoalItem
          isOpen={isOpen}
          onClose={onClose}
          openComments={openComments}
          category={goal.goal_category}
          goal={goal}
        />
      )}

      {openComments && (
        <GoalComments
          setOpenComments={setOpenComments}
          goal={goal}
          openEdit={onOpen}
          goalCategoryId={goal.goal_category.id}
        />
      )}
    </>
  );
};

export default Notifications;
